/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  	/*
	$('.toggle-main-menu').on('click', function() {
		$('#main-menu').toggle();
	});
	*/	

	
	//if you change this breakpoint in the style.css file (or _layout.scss if you use SASS), don't forget to update this value as well
	var MqL = 300;
	//move nav element position according to window width
	function checkWindowWidth() {
		//check window width (scrollbar included)
		var e = window, 
            a = 'inner';
        if (!('innerWidth' in window )) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        if ( e[ a+'Width' ] >= MqL ) {
			return true;
		} else {
			return false;
		}
	}	

	function moveNavigation(){
		var navigation = $('.nav');
  		var desktop = checkWindowWidth();
        if ( desktop ) {
			navigation.detach();
			navigation.insertBefore('.header-buttons');
		} else {
			navigation.detach();
			navigation.insertAfter('.main-content');
		}
	}
	moveNavigation();
	$(window).on('resize', function(){
		// COMMENTED OUT TO WORK. DO WE NEED IT?
		//(!window.requestAnimationFrame) ? setTimeout(moveNavigation, 300) : window.requestAnimationFrame(moveNavigation);
	});

	function closeNav() {
		$('.nav-trigger').removeClass('nav-is-visible');
		//$('.main-header').removeClass('nav-is-visible');
		$('.primary-nav').removeClass('nav-is-visible');
		$('.has-children ul').addClass('is-hidden');
		$('.has-children a').removeClass('selected');
		$('.moves-out').removeClass('moves-out');
		$('.main-content').removeClass('nav-is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
			$('body').removeClass('overflow-hidden');
		});
	}

	//mobile - open lateral menu clicking on the menu icon
	$('.nav-trigger').on('click', function(event){
		event.preventDefault();
		if( $('.main-content').hasClass('nav-is-visible') ) {
			closeNav();
			$('header.main-header').removeClass('nav-is-active');
			$('div.search').removeClass('is-visible');
			$('div.search-trigger').removeClass('search-is-visible');
			$('.overlay').removeClass('is-visible');
		} else {
			$(this).addClass('nav-is-visible');
			$('.primary-nav').addClass('nav-is-visible');
			//$('.main-header').addClass('nav-is-visible');
			$('.main-content').addClass('nav-is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
				$('body').addClass('overflow-hidden');
			});
			//toggleSearch('close');
			$('header.main-header').addClass('nav-is-active');
			$('div.search').addClass('is-visible');
			$('div.search-trigger').addClass('search-is-visible');
			$('.overlay').addClass('is-visible');
		}
	});

	//open search form
	/*
	$('.search-trigger').on('click', function(event){
		event.preventDefault();
		toggleSearch();
		closeNav();
	});
	*/

	//close lateral menu on mobile 
	
	/*
	$('.overlay').on('swiperight', function(){
		if($('.primary-nav').hasClass('nav-is-visible')) {
			closeNav();
			$('div.search').removeClass('is-visible');
			$('div.search-trigger').removeClass('search-is-visible');
			$('header.main-header').removeClass('nav-is-active');
			$('.overlay').removeClass('is-visible');
		}
	});
	$('.nav-on-left .overlay').on('swipeleft', function(){
		if($('.primary-nav').hasClass('nav-is-visible')) {
			closeNav();
			$('div.search').removeClass('is-visible');
			$('div.search-trigger').removeClass('search-is-visible');
			$('header.main-header').removeClass('nav-is-active');
			$('.overlay').removeClass('is-visible');
		}
	});
	*/
	
	
	
	$('.overlay').on('click', function(){
		closeNav();
		//toggleSearch('close');
		$('div.search').removeClass('is-visible');
		$('div.search-trigger').removeClass('search-is-visible');
		$('header.main-header').removeClass('nav-is-active');
		$('.overlay').removeClass('is-visible');
	});


	//prevent default clicking on direct children of .primary-nav 
	$('.primary-nav').children('.has-children').children('a').on('click', function(event){
		event.preventDefault();
	});
	//open submenu
	//if ((window.innerWidth > 767))  {
		// TABLET + DESKTOP
		$('.has-children').children('a').on('click', function(event){
			if( !checkWindowWidth() ) { event.preventDefault(); }
			var selected = $(this);
			if( selected.next('ul').hasClass('is-hidden') ) {
				//desktop version only
				selected.addClass('selected').next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('moves-out');
				selected.parent('.has-children').siblings('.has-children').children('ul').addClass('is-hidden').end().children('a').removeClass('selected');
				$('div.search').addClass('is-visible');
				$('div.search-trigger').addClass('search-is-visible');
				$('header.main-header').addClass('nav-is-active');
				$('.overlay').addClass('is-visible');
			} else {
				selected.removeClass('selected').next('ul').addClass('is-hidden').end().parent('.has-children').parent('ul').removeClass('moves-out');
				$('div.search').removeClass('is-visible');
				$('div.search-trigger').removeClass('search-is-visible');
				$('header.main-header').removeClass('nav-is-active');
				$('.overlay').removeClass('is-visible');
			}
			//toggleSearch('close');
		});



	
	$('.has-children').children('span.mobile-submenu').on('click', function(event){	
		var selected = $(this);
		if( selected.next('ul').hasClass('is-hidden') ) {
			selected.addClass('selected').next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('moves-out');
		}
	});






	
	/*
	} else {
		// MOBILE
		$('.has-children').children('a').on('click', function(event){
			var selected = $(this);
			if( selected.next('ul').hasClass('is-hidden') ) {
				//desktop version only
				selected.addClass('selected').next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('moves-out');
				selected.parent('.has-children').siblings('.has-children').children('ul').addClass('is-hidden').end().children('a').removeClass('selected');
				$('div.search').addClass('is-visible');
				$('div.search-trigger').addClass('search-is-visible');
				$('header.main-header').addClass('nav-is-active');
				$('.overlay').addClass('is-visible');
			} else {
				selected.removeClass('selected').next('ul').addClass('is-hidden').end().parent('.has-children').parent('ul').removeClass('moves-out');
				$('div.search').removeClass('is-visible');
				$('div.search-trigger').removeClass('search-is-visible');
				$('header.main-header').removeClass('nav-is-active');
				$('.overlay').removeClass('is-visible');
			}
			//toggleSearch('close');
		});
	}*/

	//submenu items - go back link
	$('.go-back').on('click', function(){
		$(this).parent('ul').addClass('is-hidden').parent('.has-children').parent('ul').removeClass('moves-out');
	});
	

	// cycles the carousel to frame based on thumb-id
	$('.thumb').on('click', function() {
		$('#carousel').carousel($(this).data('thumb-id'));
	});

	// active class on current slide thumb
	$('#carousel').on('slide.bs.carousel', function (e) {
		var slideTo = $(e.relatedTarget).index();
		$('.thumb').removeClass('active');
		$('*[data-thumb-id="'+slideTo+'"]').addClass('active');
	});

	// smooth scroll to anchor
	$('.smooth-scroll').click(function(e) {
		e.preventDefault();
		var dest = $(this).attr('href');
		$('html,body').animate({scrollTop: $(dest).offset().top}, 500);
	});

	// toggle mobile submenu
	$('.toggle-submenu').on('click', function() {
		var $btn = $(this);
		$btn.parent('li').toggleClass('active');
		$btn.next('ul').toggleClass('is-hidden');
		$btn.text($btn.text() === '+' ? '-' : '+');
	});
	
	
	// Hide Header on on scroll down
	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = $('header').outerHeight();
	
	$(window).scroll(function(event){
	    didScroll = true;
	});
	
	function hasScrolled() {
	    var st = $(this).scrollTop();
	    
	    // Make sure they scroll more than delta
	    if(Math.abs(lastScrollTop - st) <= delta) {
	       return;
	    }
	    
	    // If they scrolled down and are past the navbar, add class .nav-up.
	    // This is necessary so you never see what is "behind" the navbar.
	    if (st > lastScrollTop && st > navbarHeight){
	        // Scroll Down
	        if ((window.innerWidth > 767))  {
		    	$('header').removeClass('main-header-down').addClass('main-header-up');   
				closeNav();
		        $('div.search').removeClass('is-visible');
				$('div.search-trigger').removeClass('search-is-visible');
				$('header.main-header').removeClass('nav-is-active');
				$('.overlay').removeClass('is-visible');
	        }	        
	    } else {
	        // Scroll Up
	        if(st + $(window).height() < $(document).height()) {
	            $('header').removeClass('main-header-up').addClass('main-header-down');
	        }
	    }
	    
	    lastScrollTop = st;
	}
	
	setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
	}, 250);
	

})(jQuery); // Fully reference jQuery after this point.


/*jQuery(document).ready(function($){});*/
